import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { useSelector } from 'react-redux';
import { RootState } from '../../ApplicationState';
import { Icon } from '@iconify/react';
import bxChevronDown from '@iconify-icons/bx/bx-chevron-down';
import Avatar from '../Avatar';
import styles from './StudentHeaderProfile.module.scss';

const StudentHeaderProfile = () => {
  const [isShowDropdown, setShowDropdown] = useState(false);
  const history = useHistory();
  const isSmall = useMediaQuery({ maxWidth: 576 });
  const ref = useRef(null);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  });

  const userProfile = useSelector((state: RootState) => {
    return state.user.userProfile;
  });

  if (!userProfile) {
    return null;
  }

  const { firstName, lastName } = userProfile;

  const handleChevronClick = () => setShowDropdown(!isShowDropdown);

  const handleClickOutside = (e: React.MouseEvent) => {
    if (ref.current && isShowDropdown && !ref.current.contains(e.target)) {
      setShowDropdown(false);
    }
  };

  return (
    <div className={styles.container}>
      <Avatar firstName={firstName} lastName={lastName ? lastName : ''} />
      {!isSmall && firstName}&nbsp;{!isSmall && lastName}
      <div onClick={handleChevronClick} ref={ref}>
        <Icon className={styles.chevron} icon={bxChevronDown} width={28} height={28} />
        {isShowDropdown && (
          <div className={styles.dropdown}>
            <button onClick={() => history.push('/studentportal/accountSettings')}>Account Settings</button>
            <button onClick={() => history.push('/logout')}>Logout</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default StudentHeaderProfile;
